export enum DateTimeZone {
    ApplicationTimezone,
    Utc
}